import gql from 'graphql-tag'

export const GET_CONDITION_MANAGEMENTS_Q = gql`
  query GetConditionManagements($workspaceId: String!, $limit: Int, $offset: Int) {
    conditionManagements(
      queryConditionManagementsInput: { workspaceId: $workspaceId, limit: $limit, offset: $offset }
    ) {
      items {
        id
        workspaceId
        name
        createdAt
        updatedAt
        assets {
          conditionalContentId
          isActive
          priority
          cameraSourceDeviceIds
          vehicleListIds
          presentationId
          displayIds
          startDate
          endDate
          isEveryDay
          daysOfTheWeek
        }
      }
      pagination {
        totalCount
        offset
        limit
      }
    }
  }
`

export const GET_CONDITION_MANAGEMENT_Q = gql`
  query GetConditionManagement($id: String!) {
    conditionManagement(id: $id) {
      id
      workspaceId
      name
      assets {
        conditionalContentId
        isActive
        priority
        cameraSourceDeviceIds
        vehicleListIds
        presentationId
        displayIds
        startDate
        endDate
        isEveryDay
        daysOfTheWeek
      }
      createdAt
      updatedAt
    }
  }
`
